import { capabilitiesData } from "../constants/CapabilitiesConstants";

export const routes = {
  error: {
    new: '/404', // doesn't exist
  },
  login: {
    viewGeneric: `/login`, // login page
    error: '/error', // error page
  },
  iframe: '/frame', // template for a page of sorts (really not necessary)
  dashboard: '/dashboard', // main page where all content is stored (has full dashboard and important stuff)
  home: '/home', // homepage with getting started content

  authentication: '/authenticate', // page that directs to authentication
  assetAuthenticationRoutes: {
    cwb: 'cwb', // doesn't exist
    cms: 'cms', // doesn't exist
    cb360: 'cb360', // doesn't exist
  },
  operations: '/operations', // has the cloud environments listed with their content
  deliveryPipeline: '/dashboard/deliveryPipelines', // page with kaiburr.test.dcpgreendot.com’s server IP address could not be found.
  pipelineHistory: '/dashboard/deliveryPipelines/history', // /dashboard/deliveryPipelines
  accountManagement: '/dashboard/accountManagement', // shows accounts along with projects
  userManagement: '/dashboard/userManagement', // shows all users with info about them
  assetAuthorisation: '/assetAuthorisation', // simply has link with Open Cloud Cloud Managed Services can help Deloitte clients by simplifying the management of existing and new cloud workloads
  webAnalytics: '/webAnalytics', // has fake web analytics that are pretty much empty
  documentation: '/documentation', // lists all of the services across different providers that are used for terraform
  quickLinks: '/quickLinks', // just has some links to postman and some dca other stuff
  keyContacts: '/keyContacts', // has links to different contacts at DCA (e.g. Madhav and co)
  feedback: '/feedback', // Location to put feedback from users of the application
  giveFeedback: '/giveFeedback', // form to actually give the feedback
  feedbackResponse: '/feedbackResponse', // table of all the feedback
  compliancePolicies: '/compliancePolicies', // looks like it has which policies there are for all of the different projects?
  industryCompliancePolicies: '/industryCompliancePolicies', // empty graph that has the compliance percentages across a number of categories im assuming
  createEnvironments: '/createEnvironments', // doesn't exist
  assessment: '/assessment', // random series of plots
  cboSummary: '/cboSummary', // does not exist
  cboLogin: '/cbo-login', // different unused looking login screen
  cboConfigureJourney: '/cboConfigureJourney', // weird page with the alleged ability to configure your journey?  Doesn't really look implemented though
  migrate: '/migrate', // migrate specific journey flow; currently has error where it is infinitely loading
  transform: '/transform', // doesn't exist
  manage: '/manage', // shows SAP related stuff
  deliver: '/deliver', // page with timelien, cutover, deliverables, RAID, dashboard; but you can't see it if you're not signed into smartsheet
  test: '/test', // currently has a tableu server login
  assess: '/assess', // sap related info (similar to manage) but with data filled in; has lots of graphs and stuff
  dcaMigrate: '/dcaMigrate', // weird looking page similar to migrate but with just the content it looks like
  dcaManage: '/dcaManage', // similar to manage page but worse
  dcaDeliver: '/dcaDeliver', // these are all just the same thing as the above but without any things around the central components
  dcaTest: '/dcaTest', // same thing
  brownfield: '/brownfield', // shows process for doing something? Not currently implemented though
  aiArchitectureGeneration: capabilitiesData.aiArchitectureGeneration.route, // page for ai architecture generation
  aiCloudAssessments: capabilitiesData.aiCloudAssessments.route, // page for ai cloud assessments
  aiTerraformModules: capabilitiesData.aiTerraformModules.route, // page for ai terraform
  capabilities: '/capabilities', // page that displays all of the capabilities for DCA
};
